import classnames from 'classnames'
import ToggleAnimation from 'components/Animations/ToggleAnimation/ToggleAnimation'
import { ReactNode } from 'react'
import styles from './Toggle.module.css'

export enum ToggleEnableState {
  Enabled,
  NotInteractive,
  Disabled,
}

interface ToggleProps {
  isInModal?: boolean
  ariaLabel: string
  children: ReactNode
  dataTrk: string
  interactiveState: ToggleEnableState
  onClick: () => void
  selected: boolean
}

const Toggle = ({
  isInModal,
  ariaLabel,
  children,
  dataTrk,
  interactiveState,
  onClick,
  selected,
}: ToggleProps) => {
  return (
    <button
      aria-label={ariaLabel}
      className={classnames(styles.button, {
        [`${styles.disabled}`]:
          interactiveState === ToggleEnableState.Disabled && !selected,
        [`${styles.sidebarColors}`]: !isInModal,
      })}
      data-trk={dataTrk}
      disabled={
        (interactiveState === ToggleEnableState.Disabled ||
          interactiveState === ToggleEnableState.NotInteractive) &&
        !selected
      }
      onClick={onClick}
      type="button"
    >
      <span className={styles.children}>{children}</span>
      <ToggleAnimation
        className={classnames(
          styles.sliderButtonAnimation,
          styles.slidersInModal,
        )}
        selected={selected}
      />
    </button>
  )
}

export default Toggle
